import {Injectable} from '@angular/core';
import {AbstractControl, FormControl} from '@angular/forms';
import {AppSettings} from '@slarys/ufe-config';
import * as _ from 'lodash';
import {HttpClient, HttpHeaders} from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class ValidationService {

  constructor(private http: HttpClient) {}

  public ValidateChips(c: FormControl) {
    return !_.isNil(c.value) && (c.value.length > 0 && c.value.length < 26) ? null : {
      ValidateChips: {
        valid: true
      }
    };
  }

  public ValidateAlpha(control: FormControl): { [key: string]: boolean } {
    const result = (<any>window).validator.isAlpha(control.value, 'tr-TR');
    if (control.value.length && !result) {
      return { ValidateAlpha: true };
    }
    return null;
  }

  public ValidateUsername(control: FormControl) {
    if (control.value.length && !/^(?=[\w.Ã§Ä±ÄÃ¶ÅÃ¼Ã¢-]+$)(?!.*[._-]{2})(?!\.)(?!.*\.$).{3,34}$/.test(control.value)) {
      return { ValidateUsername: true };
    }
    return null;
  }

  public ValidateEmail(control: FormControl) {
    const result = (<any>window).validator.isEmail(control.value);
    if (control.value.length && !result) {
      return { ValidateEmail: true };
    }
    return null;
  }

  public ValidateTcNo(c: FormControl) {
    if (_.isNil(c.value)) {
      return {
        ValidateTcNo: {
          valid: true
        }
      };
    }
    let value = c.value || '';
    value = value.toString();
    const isEleven = /^[0-9]{11}$/.test(value);
    let totalX = 0;
    for (let i = 0; i < 10; i++) {
      totalX += Number(value.substr(i, 1));
    }
    const isRuleX = totalX % 10 == value.substr(10, 1);
    let totalY1 = 0;
    let totalY2 = 0;
    for (let i = 0; i < 10; i += 2) {
      totalY1 += Number(value.substr(i, 1));
    }
    for (let i = 1; i < 10; i += 2) {
      totalY2 += Number(value.substr(i, 1));
    }
    const isRuleY = ((totalY1 * 7) - totalY2) % 10 == value.substr(9, 0);
    return isEleven && isRuleX && isRuleY ? null : {
      ValidateTcNo: {
        valid: true
      }
    };

  }

  public ValidatePassword(c: FormControl) {
    (<any>window).owaspPasswordStrengthTest.config(AppSettings.OWASP_CONFIG);
    const result = (<any>window).owaspPasswordStrengthTest.test(c.value);
    return result.requiredTestErrors.length === 0 ? null : {
      ValidatePassword: {
        valid: true
      }
    };
  }

  public ValidatePasswordConfirm(c: AbstractControl): { ValidatePasswordConfirm: boolean } {
    const passwordField = c.get('newPassword') || c.get('password');
    if (passwordField.value !== c.get('verifyPassword').value) {
      c.get('verifyPassword').setErrors({ValidatePasswordConfirm: true});
      return {ValidatePasswordConfirm: true};
    }
    return null;
  }

  public ValidateAlphaNumeric(control: FormControl): { [key: string]: boolean } {
    if (control.value && control.value.length && !/^[a-z0-9Ã§Ä±ÄÃ¶ÅÃ¼ÃÄ°ÄÃÅÃ.,;:'+(){}\\%&/!\-_\s]+$/i.test(control.value)) {
      return { ValidateAlphaNumeric: true };
    }
    return null;
  }

  public ValidateNumeric(control: FormControl): { [key: string]: boolean } {
    if (control.value && control.value.length && !(<any>window).validator.isNumeric(control.value, {no_symbols: true})) {
      return { ValidateNumeric: true };
    }
    return null;
  }

  public ValidateAlphaAllowSpace(control: FormControl): { [key: string]: boolean } {
    if (control.value && control.value.length
      && !/^[a-zA-Z-Ã§Ä±ÄÃ¶ÅÃ¼ÃÄ°ÄÃÅÃ.,;:'+(){}\\%&/!]+(\s{0,1}[a-zA-Z-Ã§Ä±ÄÃ¶ÅÃ¼ÃÄ°ÄÃÅÃ.,;:'+(){}\\%&/! ])*$/i.test(control.value)) {
      return { ValidateAlphaAllowSpace: true };
    }
    return null;
  }

  public ValidateDate(c: FormControl) {
    return c.value !== 'Invalid date' || (<any>window).validator.isBefore(c.value) ? null : {
      ValidateDate: {
        valid: true
      }
    };
  }

  public validateResetToken(token) {
    return this.http
        .post<any>(
            AppSettings.API_ENDPOINT + '/auth/validateResetToken',
            token,
            {
              headers: new HttpHeaders({
                'Content-Type': 'application/json',
              })
            }
        )
        .pipe();
  }
}
